


import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import MapObject from '@/interfaces/entities/map-object.interface';
import ObjectReportService from "@/services/object-report.service";
import TranslationsService from "@/services/translations.service";
import FilesUploadResult from "@/interfaces/files/files.upload.result.interface";

@Component({})
export default class AppObjectReport extends Vue {

  @Prop()
  public object!: MapObject;

  @Watch('email', {immediate: false})
  public userEmail() {
    this.errors['email'] = '';
    return this.email;
  }

  @Watch('message', {immediate: false})
  public messageText(): string {
    this.errors['emptyForm'] = '';
    return this.message;
  }

  public message: string = '';
  public email: string = '';
  public images: FilesUploadResult;
  public errors: { [key: string]: string } = {emptyForm: '', email: ''};
  public reportSent: boolean = false;
  public requestFailed: boolean = false;
  public loading: boolean = false;
  public animationCssClass: string = '';
  private objectReportService: ObjectReportService = ObjectReportService.getInstance();
  private translations: TranslationsService = TranslationsService.getInstance();

  constructor() {
    super();
    this.images = new class implements FilesUploadResult {
      files: File[] = [];
      isValid: boolean = true;
    }
  }

  mounted() {
    (this.$refs.modal as HTMLElement).focus();
  }

  public close(): void {
    this.animationCssClass = 'hidden';
    setTimeout(() => this.objectReportService.closeForm(), 800);
  }

  public closeByClick(event: any): void {
    const isDesktop = window.innerWidth >= 992;
    if (isDesktop && event.target === event.currentTarget) {
      this.close();
    }
  }

  public imagesUpload(files: FilesUploadResult): void {
    this.images = files;
    this.errors['emptyForm'] = '';
  }

  public sendReport(): void {
    this.validate();
    if (this.isFormValid) {
      this.reportSent = false;
      this.requestFailed = false;
      this.loading = true;
      this.objectReportService
          .sendEmail(this.formData())
          .catch(error => this.requestFailed = true)
          .finally(() => {
            this.reportSent = true;
            this.loading = false;
          });
    }
  }

  private formData(): FormData {
    let formData = new FormData();
    for (let i = 0; i < this.images.files.length; i++) {
      let file = this.images.files[i];
      formData.append('files[' + i + ']', file);
    }
    formData.append('id', this.object.id);
    formData.append('message', this.messageText());
    formData.append('email', this.email);
    return formData;
  }

  private get isFormValid(): boolean {
    const errorMessages = Object.keys(this.errors).filter((error: string) => this.errors[error] !== '');
    return errorMessages.length === 0 && this.images.isValid;
  }

  public validate() {
    if (this.email && !this.emailRegex()) {
      this.errors['email'] = this.translations.translation('COM_MAMMADABA_MAP_REPORT_VALIDATION_EMAIL_ERROR_MESSAGE');
    }
    if (this.message === '' && this.images.files.length === 0) {
      this.errors['emptyForm'] = this.translations.translation('COM_MAMMADABA_MAP_REPORT_VALIDATION_ERROR_MESSAGE');
    }
  }

  private emailRegex(): boolean {
    const regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(this.email);
  }
}
